const offgrid_system_reducer = (state = false, action) => {

    switch(action.type) {

		case 'SETOFFGRIDSYSTEM':
            return typeof action.payload !== "undefined" ? action.payload : false;

		default:
			return state;

	}
}

export default offgrid_system_reducer;